import type React from 'react';
import { ItandiChip } from '@itandi/itandi-bb-ui';
import Styles from './FormRow.module.scss';

type Props = {
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
};

export const FormRow: React.FC<Props> = ({
  label,
  required,
  error,
  children
}) => (
  <div className={Styles.FormRow}>
    <div className={Styles.FormLabel}>
      <span className={Styles.FormLabelText}>{label}</span>
      {required && (
        <span className={Styles.RequiredLabel}>
          <ItandiChip label="必須" />
        </span>
      )}
    </div>
    <div className={Styles.FormContent}>
      {children}
      {error && <div className={Styles.ErrorMessage}>{error}</div>}
    </div>
  </div>
);
